var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.89543 0.895431 0 2 0H7C8.10457 0 9 0.895431 9 2V7C9 8.10457 8.10457 9 7 9H2C0.89543 9 0 8.10457 0 7V2ZM0 13C0 11.8954 0.895431 11 2 11H7C8.10457 11 9 11.8954 9 13V18C9 19.1046 8.10457 20 7 20H2C0.89543 20 0 19.1046 0 18V13ZM13 0C11.8954 0 11 0.89543 11 2V7C11 8.10457 11.8954 9 13 9H18C19.1046 9 20 8.10457 20 7V2C20 0.895431 19.1046 0 18 0H13ZM11 13C11 11.8954 11.8954 11 13 11H18C19.1046 11 20 11.8954 20 13V18C20 19.1046 19.1046 20 18 20H13C11.8954 20 11 19.1046 11 18V13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationFilled);
export default __webpack_public_path__ + "static/media/application-filled.67802eb39384469fd9090db0685327c3.svg";
export { ForwardRef as ReactComponent };